export default {
	'stores-are-being-brought-in': 'Stores are being brought in'
}